import React, { useContext, useEffect } from 'react'
import { ThemeContext } from 'styled-components'
import PropTypes from 'prop-types'
import styled from 'styled-components'
const Container = styled.div`
display : ${props => props.display ? props.display : props.style ? props.style.display : props.className ? props.className.display : 'flex'} ;
justify-content : ${props => props.justifyContent ? props.justifyContent : props.style ? props.style.justifyContent : props.className ? props.className.justifyContent : 'center'} ;
align-items : ${props => props.alignItems || 'center'} ;
flex-direction : ${props => props.flexDir ? props.flexDir : props.style ? props.style.flexDirection : props.className ? props.className.flexDirection : 'row'} ;
direction : ${props => props.lang === 'fa' || props.lang === 'ar' ? 'rtl' : 'ltr'} ;
position : ${props => props.position} ;
left : ${props => props.lang && (props.lang !== 'fa' && props.lang !== 'ar') ? '0px' : props.lang && (props.lang === 'fa' || props.lang === 'ar') ? 'unset' : props.left || 'unset'} ;
right : ${props => props.lang && (props.lang === 'fa' || props.lang === 'ar') ? '0px' : props.lang && (props.lang !== 'fa' || props.lang !== 'ar') ? 'unset' : props.right || 'unset'} ;
background-color : ${props => props.backgroundColor || props.theme.white} ;
width : ${props => props.width ? props.width : props.style ? props.style.width : props.className ? props.className.width : '100%'} ;
height : ${props => props.height ? props.height : props.style ? props.style.height : props.className ? props.className.height : '100%'} ;
color : ${props => props.color || props.theme.white} ;
box-shadow : ${props => props.shadow || props.theme.shadow} ;
border-radius : ${props => props.borderRadius || props.theme.radiusMd} ;
-webkit-box-shadow: ${props => props.shadow || props.theme.shadow} ;
-moz-box-shadow: ${props => props.shadow || props.theme.shadow} ;
`

const Section = props => {
    const theme = useContext(ThemeContext)
    return (
        <Container
            {...props}
            ref={props.ref}
            // width={props.width}
            // lang={props.lang}
            // shadow={props.shadow}
            className={props.className}
            theme={theme}
        >
            {props.children}
        </Container>
    )
}

export default Section
